/*eslint-env jquery*/
import { getState } from "../redux/thunks/orderThunks";
import { getLanguage } from "../redux/thunks/configurationThunks";
import {
  getOrdersSucceed,
  getOrdersFailed
} from "../redux/actions/ordersActions";
import { setKitchenConnectionState } from "../redux/actions/configurationActions";
import { cleanErrors } from "../redux/actions/serviceNotificationActions";
import * as routes from "../api/routes";

let connection = null;
let store = null;

export async function signalRInit(paramStore) {
  store = paramStore;
  signalRStart();
}

export async function signalRStart() {
  const url = routes.HUBS_URL();
  if (connection && connection.url === url) {
    return;
  }

  if (connection) {
    connection.stop();
  }

  if (!url.startsWith("http://")) {
    store.dispatch(setKitchenConnectionState(false));
    return;
  }

  connection = $.hubConnection(url, { useDefaultPath: false });

  var customerDisplayHub = connection.createHubProxy("kitchenNotificationHub");

  customerDisplayHub.on("customerDisplayMessage", function(data) {
    store.dispatch(setKitchenConnectionState(true));
    store.dispatch(getOrdersSucceed(data));
    store.dispatch(cleanErrors());
  });

  connection.stateChanged(state => {
    if (state.oldState === 2 && state.newState === 1) {
      setConnected();
    }
  });

  connection
    .start()
    .done(() => {
      setConnected();
    })
    .fail(() => {
      setDisconnected();
    });

  connection.reconnecting(() => {
    setDisconnected();
  });

  connection.disconnected(() => {
    setTimeout(() => {
      connection
        .start()
        .done(() => {
          setConnected();
        })
        .fail(() => {
          setDisconnected();
        });
    }, 5000);
  });
}

const setConnected = () => {
  store.dispatch(setKitchenConnectionState(true));
  store.dispatch(getState());
  store.dispatch(getLanguage());
  store.dispatch(cleanErrors());
};

const setDisconnected = () => {
  store.dispatch(getOrdersFailed());
  store.dispatch(setKitchenConnectionState(false));
};



// WEBPACK FOOTER //
// ./src/middleware/signalRMiddleware.js